import React from "react";
import { ProductCards as ProductCardsComponent } from "~components";

const ProductCards = ({ data }) => {
  const productIds = data.products.map((product) => product.store?.gid);

  return (
    <article>
      <ProductCardsComponent
        heading={data.headerText}
        productIds={productIds}
        linkToAllProducts={data.linkToAllProducts}
        sliceConfig={data.sliceConfig}
      />
    </article>
  );
};

export default ProductCards;
